import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import useMyStaffNotes from "./useMyStaffNotes";
import { summarizeStaffNotes } from "./staffNotePresentation";

function StaffNotesLink({ childId, userId }) {
  const data = useMyStaffNotes(childId, true, userId);
  const counts = summarizeStaffNotes(data.notes);
  return (
    <Stack spacing={0.5}>
      <Button
        component={Link}
        to="/my-notes-today"
        variant="outlined"
        sx={{ mt: 1, textTransform: "none" }}
      >
        My notes today · Review and sign originals
      </Button>
      {data.context ? (
        <Typography variant="body2">
          {counts.pending} pending · {counts.signed} signed
        </Typography>
      ) : null}
      {data.error ? (
        <Typography variant="body2">
          Documentation counts unavailable. Open your notes to retry.
        </Typography>
      ) : null}
    </Stack>
  );
}
export default function MyNotesTodayLink({ child, userId, userRole }) {
  if (["care_owner", "care_partner"].includes(userRole) && userId)
    return (
      <Button
        component={Link}
        to="/professional-documentation"
        variant="outlined"
        sx={{ mt: 1, textTransform: "none" }}
      >
        Professional Care Documentation
      </Button>
    );
  if (
    !userId ||
    userRole !== "caregiver" ||
    !child?.staffCaregivers?.[userId]?.enabled
  )
    return null;
  return <StaffNotesLink childId={child.id} userId={userId} />;
}
